import _ from 'lodash';

import { removeFromUrl } from '../url_filters';

export const getFilterTags = (filters, filterTypes, clearScheduleFilter, state, pathname) =>
  _.flattenDeep(
    _.map(filterTypes, filterType => {
      const filterTypeLabel = _.get(filterType, 'label');
      const filterTypeName = _.get(filterType, 'name');
      const filterTypePillLabel = _.get(filterType, 'pillLabel');

      return _.map(_.get(filters, filterTypeName), code => ({
        key: `${filterTypeName}-${code}`,
        label: filterTypeLabel,
        pillLabel: filterTypePillLabel,
        value: _.get(filterType, ['types', code, 'name']),
        onClearFilter: () => {
          clearScheduleFilter(filterTypeName, code);
          if (state && pathname) {
            removeFromUrl(
              filterTypeName,
              _.get(filterType, ['types', code, 'code']) ||
                _.get(filterType, ['types', code, 'id']),
              state,
              pathname,
            );
          }
        },
      }));
    }),
  );

export const getReservationFilterTags = (filters, filterTypes, cleaFilter) =>
  _.flattenDeep(
    _.map(filterTypes, filterType => {
      const filterTypeLabel = _.get(filterType, 'title');
      const filterTypeName = _.get(filterType, 'name');
      return _.map(_.get(filters, filterTypeName), code => {
        const option = _.find(_.get(filterType, 'options'), { value: code });
        return {
          key: `${filterTypeName}-${code}`,
          label: filterTypeLabel,
          value: _.get(option, 'label', ''),
          onClearFilter: () => {
            cleaFilter(filterTypeName, code);
          },
        };
      });
    }),
  );

export const getFilterOptions = options =>
  _.map(options, option => {
    const label = _.get(option, 'name', _.get(option, 'label'));
    const value = _.get(option, 'id', _.get(option, 'value', _.get(option, 'code')));
    const key = `${label}-${value}`;

    return {
      key,
      label,
      value,
    };
  });

export const getFilterCounts = options => _.mapValues(_.keyBy(options, 'code'), 'count');

// Selector Utils
export const getActiveFilters = (filters, validFilters) => {
  const activeFilters = [];
  _.forEach(filters, (values, filterName) => {
    if (_.includes(validFilters, filterName) && _.size(values) > 0) {
      activeFilters.push({ filterName, values });
    }
  });
  return activeFilters;
};
